import { ControlFacet } from '../models/controls/ControlFacet';
import { LayoutTypeFacet } from '../models/layouts/LayoutTypeFacet';
import { IItemCacheThunkAction } from '../store/actions/ItemCacheActions';

/**
 * Control hook for configuring the Tiles layout for an item set.
 */
export const switchLayoutActionControl: ControlFacet<{}, {
  /**
   * Callback for whenever switch layout action is performed.
   */
  onSwitchLayout: (params: {
    itemsScopeItemKey: string;
    layoutType: LayoutTypeFacet
  }) => IItemCacheThunkAction<void>;
}> = new ControlFacet('switchLayoutActionControl');
